import { create } from 'zustand';
import type { AdminUser } from '@/types';

interface AuthState {
  token: string | null;
  admin: AdminUser | null;
  setAuth: (token: string, admin: AdminUser) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  token: localStorage.getItem('admin_token'),
  admin: null,

  setAuth: (token, admin) => {
    localStorage.setItem('admin_token', token);
    set({ token, admin });
  },

  clearAuth: () => {
    localStorage.removeItem('admin_token');
    set({ token: null, admin: null });
  },
}));
